import {
  anEntityFieldAndType,
  anEntityInterface,
  mockEntityFieldsAndIndicatorQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockEntityFieldsAndIndicator = {
  __typename: 'Query',
  entityFieldsWithTypes: [anEntityFieldAndType()],
  entity: anEntityInterface(),
};

export const handlers = [
  mockEntityFieldsAndIndicatorQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entityFieldsWithTypes: [anEntityFieldAndType()],
          entity: anEntityInterface(),
        },
      });
    }
  ),
];
